// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"75dccd76","239":"87568fc2","455":"e50155fd"}[chunkId] + ".chunk.js";
};